import { render, staticRenderFns } from "./IbSingleAccordion.vue?vue&type=template&id=59023b27&scoped=true"
import script from "./IbSingleAccordion.vue?vue&type=script&lang=js"
export * from "./IbSingleAccordion.vue?vue&type=script&lang=js"
import style0 from "./IbSingleAccordion.vue?vue&type=style&index=0&id=59023b27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59023b27",
  null
  
)

export default component.exports